import { withDefaults } from "~/common/hoc/withDefaults";
import { Typography, type TypographyProps } from "~/common/mui";

const Title = withDefaults(Typography as React.ComponentType<TypographyProps>, {
  component: "h1",
  variant: "headlineLarge",
  fontWeight: "bold",
});

const Subtitle = withDefaults(Typography as React.ComponentType<TypographyProps>, {
  variant: "headlineSmall",
  color: "textSecondary",
});

export const PageElements = {
  Title,
  Subtitle,
};
